module.exports = __webpack_public_path__ + "img/default-image.0a2d1640.png";